import React from 'react';
import {TrendType} from 'records/TriggerTrend';
import './SmartAlertTrendDescription.styl';

const {AVERAGE_OF_TIMES} = TrendType;

export default class SmartAlertTrendDescription extends React.Component {
  render() {
    const {trend} = this.props;
    const {trendType} = trend;

    return (
      <div className="smart-alert-trend-description">
        When the {trendType === AVERAGE_OF_TIMES ? 'average ' : ' '}
        number of times that this happens:
        <ul>
          {trendType === AVERAGE_OF_TIMES && <li>per {trend.getSubPeriodText().toLowerCase()}</li>}
          <li>over {trend.getPeriodText()}</li>
          <li>is {trend.getThresholdText().toLowerCase()}</li>
        </ul>
      </div>
    );
  }
}
